import "./SignIn.scss"
import React, {useEffect, useState} from "react";
import {Link, Navigate, Route, Routes, useLocation} from "react-router-dom";
import SignInEnterPhoneNumber from "./signInEnterPhoneNumber/SignInEnterPhoneNumber";
import {RouteHelper} from "../../route/RouteHelper";
import {css} from "@emotion/css";
import SignInEnterSubmitCode from "./signInEnterSubmitCode/SignInEnterSubmitCode";
import SignInForgetPassword from "./signInForgetPassword/SignInForgetPassword";
import SignInRefreshPassword from "./signInRefreshPassword/SignInRefreshPassword";
import {RaikoBaseCardContainer, RaikoLineStepper} from "@moeindal/base-raiko-panel-components";

const SignIn = () => {

    const [steps, setSteps] = useState(1);

    const location = useLocation()


    function handleChangeStep(newStep) {
        setSteps(newStep)
    }

    useEffect(() => {

        if (location.pathname === RouteHelper.SignInEnterPhoneNumber.globalUrl) {
            handleChangeStep(1)
        } else if (location.pathname === RouteHelper.SignInEnterSubmitCode.globalUrl) {
            handleChangeStep(2)
        }

    }, [location.pathname]);

    return (
        <>
            <div className={"baseSignInContainer"}>
                <RaikoBaseCardContainer className={"signInPageContainer"}>
                    <div className={"signInPageContentContainer"}>

                        <div className={"pageInfoContainer"}>
                            <div className={css`height: 100%;
                              width: 100%;`}>
                                <Routes>
                                    <Route
                                        path={RouteHelper.SignInEnterPhoneNumber.url}
                                        element={<SignInEnterPhoneNumber/>}
                                    />
                                    <Route
                                        path={RouteHelper.SignInEnterSubmitCode.url}
                                        element={<SignInEnterSubmitCode/>}
                                    />
                                    <Route
                                        path={RouteHelper.SignInForgetPassword.url}
                                        element={<SignInForgetPassword/>}
                                    />
                                    <Route
                                        path={RouteHelper.SignInRefreshPassword.url}
                                        element={<SignInRefreshPassword/>}
                                    />
                                    <Route
                                        path={"/*"}
                                        element={<Navigate replace to={RouteHelper.SignInEnterPhoneNumber.globalUrl}/>}
                                    />
                                </Routes>
                            </div>
                            <RaikoLineStepper numberOfSteps={3} currentStep={steps}/>
                        </div>
                        {/*<div className={"pageSubInfoContainer"}>
                        <div className={"pageSubInfoHelperLinkContainer"}>
                            <Link to={"/"}>
                                <span>راهنمای ثبت نام</span>
                            </Link>
                            <span>|</span>
                            <Link to={"/"}>
                                <span>تماس با پشتیبانی</span>
                            </Link>
                        </div>
                    </div>*/}
                    </div>
                    {/*<img src={sidebarBanner} alt="banner" className={"sidebarBanner"}/>*/}
                </RaikoBaseCardContainer>
            </div>
        </>
    )
}

export default SignIn;